import styled from "styled-components"

export const ExpressionEditorWrapper = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
`
export const ExpressionEditorFormatted = styled.div`
    height: 33px;
    width: 100%;
    margin-bottom: 8px;
    padding: 6px 12px;
    outline: none;
    line-height: 21px;
    overflow: hidden;
    white-space: nowrap;
    color: ${(props) => props.theme.inputColor};
    background: ${(props) => props.theme.inputBackground};

    & > span.variable {
        color: ${(props) => props.theme.markovVariableColor};
    }

    &:focus {
        color: ${(props) => props.theme.inputFocusColor};
        caret-color: ${(props) => props.theme.inputFocusColor};

        & > span.variable {
            color: ${(props) => props.theme.markovVariableFocusColor};
        }
    }
`
export const VariableDropdownList = styled.div<{
    show: boolean
}>`
    position: absolute;
    top: 33px;
    left: 0;
    z-index: 1;
    width: 100%;
    display: ${(props) => (props.show ? "block" : "none")};
    height: fit-content;
    max-height: 200px;
    overflow-y: scroll;
    border-left: 1px solid;
    border-right: 1px solid;
    border-color: ${(props) => props.theme.selectDropdownBackground};
    background: ${(props) => props.theme.selectDropdownBackground};
`
export const VariableDropdownItem = styled.div`
    display: flex;
    align-items: center;
    overflow: hidden;
    padding: 6px 24px 6px 12px;
    font-size: 14px;
    cursor: pointer;
    color: ${(props) => props.theme.selectDropdownItemColor};
    background: transparent;
    transition: 0.2s ease;

    &:hover {
        color: ${(props) => props.theme.selectDropdownItemHoverColor};
        background: ${(props) => props.theme.selectDropdownHoverBackground};
    }
`
